import React from 'react';
import {
  SiClaude, SiGooglegemini, SiMistralai, SiHuggingface,
  SiTypescript, SiJavascript, SiReact, SiNextdotjs, SiVuedotjs, SiAngular, SiNodedotjs,
  SiPython, SiFastapi, SiDjango, SiPytorch, SiPandas, SiDotnet, SiKotlin, SiSpringboot,
  SiAndroid, SiSwift, SiGo, SiRust, SiPostgresql, SiMysql, SiDart, SiRuby, SiPhp,
  SiFlutter, SiRubyonrails, SiLaravel, SiCplusplus, SiGraphql, SiOpenapiinitiative,
  SiSap, SiShopify, SiStripe, SiDocker, SiKubernetes, SiTerraform, SiGithubactions,
  SiGooglecloud, SiOpentelemetry, SiJest, SiPytest, SiRedis, SiApacheairflow,
  SiSnowflake, SiDatabricks, SiElasticsearch, SiNpm, SiStorybook
} from 'react-icons/si';
import { TbBrandOpenai, TbBrandCSharp, TbBrandAzure } from 'react-icons/tb';
import { FaAws, FaMicrosoft, FaJava, FaSalesforce } from 'react-icons/fa';

// Brand silhouettes come from the installed React Icons collections, not generated artwork.
// Provider marks are explicitly labeled when a card describes a provider's product.
const brands = {
 'OpenAI': [TbBrandOpenai, '#202123'], 'Claude': [SiClaude, '#b35c3d'],
 'Gemini': [SiGooglegemini, '#536fc5'], 'Microsoft': [FaMicrosoft, '#5e5e5e'],
 'AWS': [FaAws, '#232f3e'], 'Mistral AI': [SiMistralai, '#c65c06'], 'Hugging Face': [SiHuggingface, '#a87500'],
 'TypeScript': [SiTypescript, '#3178c6'], 'JavaScript': [SiJavascript, '#8a7100'],
 'React': [SiReact, '#087ea4'], 'Next.js': [SiNextdotjs, '#171717'], 'Vue': [SiVuedotjs, '#27835b'],
 'Angular': [SiAngular, '#c3002f'], 'Node.js': [SiNodedotjs, '#417e38'],
 'Python': [SiPython, '#3776ab'], 'FastAPI': [SiFastapi, '#008477'], 'Django': [SiDjango, '#092e20'],
 'PyTorch': [SiPytorch, '#c44731'], 'pandas': [SiPandas, '#150458'], 'C#': [TbBrandCSharp, '#68217a'],
 '.NET': [SiDotnet, '#512bd4'], 'Java': [FaJava, '#a43a23'], 'Kotlin': [SiKotlin, '#7f52d5'],
 'Spring Boot': [SiSpringboot, '#477e26'], 'Android': [SiAndroid, '#22844c'], 'Swift': [SiSwift, '#c94725'],
 'Go': [SiGo, '#007d9c'], 'Rust': [SiRust, '#252525'], 'PostgreSQL': [SiPostgresql, '#4169a1'],
 'MySQL': [SiMysql, '#4479a1'], 'Dart': [SiDart, '#0175c2'], 'Ruby': [SiRuby, '#cc342d'],
 'PHP': [SiPhp, '#66699c'], 'Flutter': [SiFlutter, '#0277bd'], 'Rails': [SiRubyonrails, '#cc0000'],
 'Laravel': [SiLaravel, '#d7352a'], 'C++': [SiCplusplus, '#00599c'], 'GraphQL': [SiGraphql, '#c82191'],
 'OpenAPI': [SiOpenapiinitiative, '#567f26'], 'Salesforce': [FaSalesforce, '#0079b6'],
 'SAP': [SiSap, '#0078aa'], 'Shopify': [SiShopify, '#5d812e'], 'Stripe': [SiStripe, '#635bff'],
 'Docker': [SiDocker, '#1974c7'], 'Kubernetes': [SiKubernetes, '#326ce5'],
 'Terraform': [SiTerraform, '#844fba'], 'GitHub Actions': [SiGithubactions, '#2088ff'],
 'Google Cloud': [SiGooglecloud, '#4285f4'], 'Azure': [TbBrandAzure, '#0078d4'],
 'OpenTelemetry': [SiOpentelemetry, '#425cc7'], 'Jest': [SiJest, '#99425b'], 'pytest': [SiPytest, '#0876a3'],
 'Redis': [SiRedis, '#c6302b'], 'Airflow': [SiApacheairflow, '#28777b'], 'Snowflake': [SiSnowflake, '#227fa5'],
 'Databricks': [SiDatabricks, '#d84435'], 'Elasticsearch': [SiElasticsearch, '#176c78'],
 'npm': [SiNpm, '#cb3837'], 'Storybook': [SiStorybook, '#d62e67']
};

export const platformBrands = {
 'ChatGPT & OpenAI': ['OpenAI'], 'Claude & Anthropic': ['Claude'], 'Google Gemini': ['Gemini'],
 'Microsoft Foundry': ['Microsoft'], 'Amazon Bedrock': ['AWS'],
 'Mistral & open-model ecosystems': ['Mistral AI', 'Hugging Face']
};
export const languageBrands = {
 'TypeScript & JavaScript': ['TypeScript', 'JavaScript'], 'Python': ['Python'], 'C# & .NET': ['C#', '.NET'],
 'Java & Kotlin': ['Java', 'Kotlin'], 'Swift': ['Swift'], 'Go & Rust': ['Go', 'Rust'],
 'SQL': ['PostgreSQL', 'MySQL'], 'Dart, Ruby & PHP': ['Dart', 'Ruby', 'PHP'], 'C++ & specialized ecosystems': ['C++']
};
export const frameworkBrands = {
 'TypeScript & JavaScript': ['React', 'Next.js', 'Vue', 'Angular', 'Node.js'],
 'Python': ['FastAPI', 'Django', 'PyTorch', 'pandas'], 'Java & Kotlin': ['Spring Boot', 'Android'],
 'Dart, Ruby & PHP': ['Flutter', 'Rails', 'Laravel']
};
export const capabilityBrands = {
 'API design & engineering': ['GraphQL', 'OpenAPI'], 'Enterprise connectors': ['Salesforce', 'SAP', 'Shopify', 'Stripe'],
 'Custom libraries & SDKs': ['TypeScript', 'Python', 'npm'], 'Design systems': ['React', 'Storybook'],
 'Developer platforms': ['GitHub Actions', 'Docker'], 'Operational storage': ['PostgreSQL', 'MySQL', 'Redis'],
 'Pipelines & analytics': ['Airflow', 'Snowflake', 'Databricks'], 'Retrieval & search': ['PostgreSQL', 'Elasticsearch'],
 'Cloud architecture': ['AWS', 'Azure', 'Google Cloud'], 'Delivery automation': ['Docker', 'Kubernetes', 'Terraform', 'GitHub Actions'],
 'Observability & reliability': ['OpenTelemetry'], 'Automated quality engineering': ['Jest', 'pytest']
};

export function BrandRow({ names, prominent = false }) {
 if (!names?.length) return null;
 return <ul className={`tech-brand-row${prominent ? ' tech-brand-row-prominent' : ''}`} aria-label="Technologies">
  {names.map(name => {
   const [Icon, color] = brands[name];
   return <li key={name}><span className="tech-brand-icon" style={{ color }}><Icon aria-hidden="true" focusable="false" /></span><span>{name}</span></li>;
  })}
 </ul>;
}
